export const MODAL = {
  TEXTS: {
    BODY: {
      FIRST:
        'Tenemos que verificar que no eres un robot. Por favor, completa el siguiente control de seguridad.',
    },
    TITLE: '¿Eres humano?',
  },
}
